import { render } from "./activityCreate.vue?vue&type=template&id=94326b62&scoped=true"
import script from "./activityCreate.vue?vue&type=script&lang=js"
export * from "./activityCreate.vue?vue&type=script&lang=js"

import "./activityCreate.vue?vue&type=style&index=0&id=94326b62&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94326b62"]])

export default __exports__